import { ValidatorResult } from './types';

export const VALIDATION_INN = 'validators:inn';

const checkInnStep = (inn: number[], lastIndex: number): boolean => {
  const weights = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
  const sum = inn
    .slice(0, lastIndex)
    .reduce((result, digit, i) => result + digit * weights[i + weights.length - lastIndex], 0);

  return (sum % 11) % 10 === inn[lastIndex];
};

const isValidInn = (value: string): boolean => {
  const inn = value
    .trim()
    .split('')
    .map(ch => parseInt(ch, 10));

  if (inn.length === 12) {
    return checkInnStep(inn, 10) && checkInnStep(inn, 11);
  }

  if (inn.length === 10) {
    return checkInnStep(inn, 9);
  }

  return false;
};

export const inn =
  (key = VALIDATION_INN) =>
  (value: string): ValidatorResult =>
    value && !isValidInn(value) ? { key, options: {} } : false;
